import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoCartOutline } from "react-icons/io5";
import { useDispatch } from 'react-redux';
import { addToCart } from '../features/products/productSlice';
import { removeCoupon } from '../features/products/productSlice';
import { FaRegStar, FaStar } from "react-icons/fa";
import Rating from 'react-rating';
import placeholder_image from '../img/placeholder-image.jpeg';


function ProductCard({ product, admin = false }) {
  const dispatch = useDispatch();

  const handleAddToCart = () => {
    dispatch(addToCart({
      ...product,
      variant: product.variants[0]
    }));
    dispatch(removeCoupon());
  }

  const currentLang = localStorage.getItem('lang') || 'lv';

  const getPrice = () => {
    // Helper function to format price
    const formatPrice = (price) => (price / 100).toFixed(2);
  
    // If there are multiple variants
    if (product.variants.length > 1) {
      // Get the cheapest and most expensive variant prices
      const cheapest_product = product.variants.reduce((prev, current) => prev.price < current.price ? prev : current);
      const expensive_product = product.variants.reduce((prev, current) => prev.price > current.price ? prev : current);
  
      const cheapest = cheapest_product.discount_price ? cheapest_product.discount_price : cheapest_product.price;
      const expensive = expensive_product.discount_price ? expensive_product.discount_price : expensive_product.price;
  
      // If the cheapest and most expensive prices are the same, return a single price
      if (cheapest === expensive) {
        return `${formatPrice(cheapest)}€`;
      } else {
        return `${formatPrice(cheapest)}-${formatPrice(expensive)}€`;
      }
  
    // If there is only one variant
    } else {
      const price = product.variants[0].discount_price ? product.variants[0].discount_price : product.variants[0].price;
      return `${formatPrice(price)}€`;
    }
  }

  const hasDiscount = () => {
    return product.variants.some(variant => variant.discount_price);
  }

  const outOfStock = () => {
    return product.variants.every(variant => variant.countInStock < 1);
  }

  if(!product || !product.variants) {
    return null
  }

  return (
    <div className="product-grid-card">
      <div className="card-top">
        <Link to={`/product/${product._id}`}>
          <div className="product-card-image-container">
            {outOfStock() && (
              <div className="out-of-stock">
                {currentLang === 'en' ? 'Out of Stock' : 'Nav noliktavā'}
              </div>
            )}
            {(!outOfStock() && hasDiscount())  && (
              <div className="discount">
                {currentLang === 'en' ? 'Discount' : 'Atlaide'}
              </div>
            )}
            <img src={product.image && product.image.src ? product.image.src : placeholder_image} alt="Product" className="product-image" />
          </div>
        </Link>
        <div className="padding-10-bottom"></div>
        <Link to={`/product/${product._id}`}>
          <h3 className="product-title">
            {currentLang === 'en' ? (product.title_english || product.title) : product.title}
          </h3>
        </Link>
        <Link to={`/product/${product._id}`}>
          <p className="product-description">
            {currentLang === 'en' ? (product.short_description_english || product.short_description) : product.short_description}
          </p>
        </Link>

        {product.rating && 
          <Rating 
            emptySymbol={<FaRegStar size={15} color="#ffc000" />}
            fullSymbol={<FaStar size={15} color="#ffc000" />}
            initialRating={product.rating}
            readonly
          />
        }
      </div>
      <div className="card-bottom">
        <div className="product-actions">
          <p className={`product-price`}>
            {!admin &&
              <>
                <span>{getPrice()}</span>
              </>
            }
          </p>
          {!admin && (
            <button 
              className={`add-to-cart-button ${outOfStock() ? 'out-of-stock' : ''}`} 
              disabled={outOfStock()} 
              onClick={handleAddToCart}
            >
              <IoCartOutline size={25}/>
            </button>
          )}  
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
